import { SimpleProduct, ProductWarehouseInventoryInformation, ProductPrice, RecommendedElement } from '@msdyn365-commerce/retail-proxy';
import {
    getByIdsAsync,
    getEstimatedAvailabilityAsync,
    getActivePricesAsync
} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { getElementsAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/RecommendationsDataActions.g';

import { ICartDataSet } from './components-interfaces-definition';

import { IBtrtsKioskv3Footer2Data } from '../btrts-kioskv3-footer-2.data';
import { IBtrtsKioskv3Footer2Props } from '../btrts-kioskv3-footer-2.props.autogenerated';

export async function getProductListFromCuratedList(props: IBtrtsKioskv3Footer2Props<IBtrtsKioskv3Footer2Data>): Promise<ICartDataSet> {
    const { context, config } = props;
    const projectDomain = {
        ChannelId: +context.actionContext.requestContext.apiSettings.channelId,
        CatalogId: +context.actionContext.requestContext.apiSettings.catalogId
    };

    //let recommendedElements: RecommendedElement[];

    let simpleProductsResults: SimpleProduct[] = [];
    let activePricesResult: ProductPrice[] = [];
    let productsAvailabilityResults: ProductWarehouseInventoryInformation = {};
    const productIds: number[] = [];
    let resultObject: ICartDataSet = {};

    const recommendedElements: RecommendedElement[] = await getElementsAsync(
        { callerContext: context.actionContext },
        config.curatedListId,
        null
    );

    if (recommendedElements) {
        recommendedElements.map(product => productIds.push(Number(product.ElementId)));
        simpleProductsResults = await getByIdsAsync(
            { callerContext: context.actionContext },
            context.request.apiSettings.channelId,
            productIds
        );
        productsAvailabilityResults = await getEstimatedAvailabilityAsync(
            { callerContext: context.actionContext },
            { ProductIds: productIds, DefaultWarehouseOnly: true }
        );
        activePricesResult = await getActivePricesAsync(
            { callerContext: context.actionContext, queryResultSettings: {} },
            projectDomain,
            productIds,
            new Date(),
            null,
            [],
            true
        );
    }

    resultObject = {
        productIds: productIds,
        // selectedProducts: productSearchResult,
        productsSimpleDetails: simpleProductsResults,
        productsAvailability: productsAvailabilityResults,
        activePrices: activePricesResult
    };

    return resultObject;
}
